import React, { useEffect, useState } from "react";
import SingleFormLayout from "./SingleFormLayout";
import EmployeeForm from "../EmployeeManagement/Employees/EmployeesForm";
import EmployeeContactForm from "../EmployeeManagement/EmployeeContactDetails/EmployeeContactForm";
import EmployeeAddressForm from "../EmployeeManagement/EmployeeAddress/EmployeeAddressForm";
import EmployeeEducationForm from "../EmployeeManagement/EmployeeEducation/EmployeeEducationForm";
import EmployeeAddPrerequisitesAlert from "../EmployeeManagement/Employees/EmployeeAddPrerequisitesAlert";
import { Box } from "@mui/material";
import SubmitButton from "./SubmitButton";
import CommonFormLayout from "../EmsOptimized/Form/CommonFormLayout";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import { fetchEmployeeSetupStatus } from "../../Utils/employeeSetupConfig";
import { useNavigate } from "react-router-dom";

const sections = [
  {
    id: "profile",
    title: "Employee Details",
    subtitle: "Profile and employment information",
    customComponent: EmployeeForm,
  },
  {
    id: "education",
    title: "Education",
    customComponent: EmployeeEducationForm,
  },
  {
    id: "address",
    title: "Address",
    customComponent: EmployeeAddressForm,
  },
  {
    id: "contact",
    title: "Contact",
    customComponent: EmployeeContactForm,
  },
];

const DynamicFormPage = ({ mode }) => {
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const navigate = useNavigate();
  const [checkingSetup, setCheckingSetup] = useState(mode === "add");
  const [setupReady, setSetupReady] = useState(mode !== "add");
  const [missingSetup, setMissingSetup] = useState({});

  useEffect(() => {
    if (mode !== "add" || !org?.organization_id) {
      setCheckingSetup(false);
      setSetupReady(true);
      setMissingSetup({});
      return;
    }

    let cancelled = false;
    setCheckingSetup(true);

    fetchEmployeeSetupStatus(org.organization_id)
      .then(({ ready, missing }) => {
        if (cancelled) return;
        setSetupReady(ready);
        setMissingSetup(missing);
      })
      .catch(() => {
        if (cancelled) return;
        setSetupReady(false);
        setMissingSetup({
          departments: true,
          designations: true,
          workShifts: true,
        });
      })
      .finally(() => {
        if (!cancelled) {
          setCheckingSetup(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [mode, org?.organization_id]);

  const showFooter = setupReady && !checkingSetup;

  return (
    <CommonFormLayout
      mode={mode}
      loading={mode === "add" && checkingSetup}
      hideFooter
      footerContent={
        showFooter ? (
          <>
            {mode !== "view" && (
              <button
                type="button"
                className="ems-btn ems-ghost"
                onClick={() => navigate("/organization/employee/employee-details")}
              >
                Cancel
              </button>
            )}
            <SubmitButton mode={mode} />
          </>
        ) : null
      }
      headerProps={{
        addMessage: "Add Employee",
        updateMessage: "Update Employee",
        homeLink: "/organization/employee/employee-details",
        homeText: "Employees",
      }}
    >
      {mode === "add" && !checkingSetup && !setupReady && (
        <>
          <EmployeeAddPrerequisitesAlert missing={missingSetup} />
          <Box display="flex" justifyContent="center" mt={2}>
            <button
              type="button"
              className="ems-btn ems-ghost"
              onClick={() => navigate("/organization/employee/employee-details")}
            >
              Back to Employees
            </button>
          </Box>
        </>
      )}

      {setupReady && !checkingSetup && (
        <SingleFormLayout sections={sections} mode={mode} />
      )}
    </CommonFormLayout>
  );
};

export default DynamicFormPage;
